var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginHome"},[_vm._v(" 欢迎使用智能巡检管理平台 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }